const Gifts = Go.vue;
export default Gifts;
